import React , {useEffect} from 'react';
import { authService } from '../../utils/authService'
import BusySpinner from '../spinners/BusySpinner';

const LoginRedirect = () => {
    useEffect(() => {
        authService.handleLogin();
      }, []); 
    
      return (
        <BusySpinner busy={true}/>
        );
}

export default LoginRedirect;